import { render, staticRenderFns } from "./BIParametersFilter.vue?vue&type=template&id=7e38c145&scoped=true&"
import script from "./BIParametersFilter.vue?vue&type=script&lang=js&"
export * from "./BIParametersFilter.vue?vue&type=script&lang=js&"
import style0 from "./BIParametersFilter.vue?vue&type=style&index=0&id=7e38c145&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e38c145",
  null
  
)

export default component.exports